<template>
	<div
		class="relative flex h-[300px] w-full flex-col overflow-hidden rounded bg-gradient-to-br from-[#259BE0] to-[#0273E4] p-6 sm:h-full"
	>
		<CarbarImage
			image="img/partners/carsales/img-cta-carbar.webp"
			alt-text="Carbar mission"
			image-width-class="w-auto"
			image-height-class="h-[200px] md:h-[240px] xl:h-[200px]"
			class="absolute bottom-0 right-0"
		/>
		<div class="flex flex-col gap-1">
			<h4 class="text-xl font-bold text-white">
				What if you could try a car like a streaming service?
			</h4>
			<p class="m-0 p-0 text-base text-white">
				Subscribe to a used car, drive it your way, and cancel when life
				changes.
			</p>
			<CarbarLink
				href="/cars/subscribe"
				class="mt-4 w-fit"
				:underline="false"
			>
				<CarbarButton
					:is-full-width="false"
					:is-outline="true"
					:is-mixed="true"
					:rounded="whitelabel.styles?.button?.borderRadius"
					custom-outline-color="border border-white hover:border-orange-400 bg-transparent hover:bg-orange-400"
					class="text-white"
				>
					Browse cars
				</CarbarButton>
			</CarbarLink>
		</div>
	</div>
</template>

<script setup>
import CarbarButton from '@/components/buttons/CarbarButton.vue'
import CarbarLink from '@/components/links/CarbarLink.vue'

const { whitelabel } = useWhitelabelsStyles()
</script>
